
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Default Hidden Columns" fileName="default-hidden-column.md" />
        <p>The following example hides the hobby and name columns by default</p>
<demo-block>
        <div><p>Set the default hidden columns through the <code>defaultHiddenColumnKeys</code> property</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; :columnHiddenOption=&quot;columnHiddenOption&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columnHiddenOption: {
                    // default hidden column keys
                    defaultHiddenColumnKeys: [&quot;hobby&quot;, &quot;name&quot;],
                },
                columns: [
                    { field: &quot;name&quot;, key: &quot;name&quot;, title: &quot;Name&quot; },
                    { field: &quot;date&quot;, key: &quot;date&quot;, title: &quot;Date&quot; },
                    { field: &quot;hobby&quot;, key: &quot;hobby&quot;, title: &quot;Hobby&quot; },
                    { field: &quot;address&quot;, key: &quot;address&quot;, title: &quot;Address&quot; },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"columnHiddenOption":_vm.columnHiddenOption}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columnHiddenOption: {
                    // default hidden column keys
                    defaultHiddenColumnKeys: ["hobby", "name"],
                },
                columns: [
                    { field: "name", key: "name", title: "Name" },
                    { field: "date", key: "date", title: "Date" },
                    { field: "hobby", key: "hobby", title: "Hobby" },
                    { field: "address", key: "address", title: "Address" },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  